// Vendor imports
const classNames = require('classnames')
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Icon = require('client-v2/common/containers/icons/component')
const PromoBadge = require('client-v2/common/containers/promo-badge/component-smart')

const bem = BemEntity('AppFooter')

const SOCIAL_ACCOUNTS = [
  {
    provider: 'instagram',
    href: 'https://instagram.com/getmixapp',
    title: 'Check us out on Instagram'
  },
  {
    provider: 'facebook',
    href: 'https://facebook.com/getmix',
    title: 'Friend us on Facebook'
  },
  {
    provider: 'twitter',
    href: 'https://twitter.com/getmixapp',
    title: 'Follow us on Twitter'
  }
]

class AppFooter extends React.PureComponent {

  renderBrandingColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'branding')
      },
        tag(Icon, {
          className: bem.element('logomark'),
          id: 'mix-logomark'
        })
      )
    )
  }

  renderCompanyColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'company')
      },
        this.renderContactHref(),
        this.renderHref('Careers', '/careers'),
        this.renderHref('Press', 'mailto:press@mix.com'),
        this.renderHref('Terms', '/tos'),
        this.renderHref('Privacy', '/privacy'),
        this.renderHref('Guidelines', 'https://support.mix.com/community-rules/mix-community-guidelines'),
        this.renderHref('Community', 'https://community.mix.com')
      )
    )
  }

  renderContactHref() {
    return (
      tag('a', {
        className: bem.element('href'),
        href: 'mailto:support@mix.com',
        onClick: this.props.onContactClick
      },
        'Contact Us'
      )
    )
  }

  renderCopyright() {
    const currentYear = (new Date()).getUTCFullYear()
    return (
      tag('div', {
        className: bem.element('copyright')
      },
        `© ${currentYear} Mix is an `,
        tag('a', {
          className: bem.element('copyright-href'),
          href: 'https://expa.com/'
        },
          'Expa'
        ),
        ' company'
      )
    )
  }

  renderDownloadColumn() {
    return (
      tag('div', {
        className: bem.element('column', 'download')
      },
        tag('div', {
          className: bem.element('download-container')
        },
          tag('div', {
            className: bem.element('badges', 'apps')
          },
            this.renderHeading('Mobile apps', 'download'),
            tag(PromoBadge, {
              className: bem.element('badge'),
              id: 'ios'
            }),
            tag(PromoBadge, {
              className: bem.element('badge'),
              id: 'android'
            })
          ),
          tag('div', {
            className: bem.element('badges', 'extensions')
          },
            this.renderHeading('Browser extensions', 'download'),
            tag(PromoBadge, {
              className: bem.element('badge'),
              id: 'chrome'
            }),
            tag(PromoBadge, {
              className: bem.element('badge'),
              id: 'firefox'
            }),
            tag(PromoBadge, {
              className: bem.element('badge'),
              id: 'msedge'
            })
          )
        ),
        tag('div', {
          className: bem.element('badges', 'buttons')
        },
          tag('a', {
            className: bem.element('href'),
            href: 'https://community.mix.com/blog/2018/7/12/add-mix-button'
          },
            'Add a Mix Button to Your Site'
          )
        )
      )
    )
  }

  renderFollowColumn() {
    const accountSection = this.props.loggedIn && [
      this.renderHref('Settings', '/settings'),
      this.renderHref('Log out', '/logout')
    ]
    return (
      tag('div', {
        className: bem.element('column', 'follow')
      },
        this.renderHref('Instagram', 'https://instagram.com/getmixapp'),
        this.renderHref('Facebook', 'https://facebook.com/getmix'),
        this.renderHref('Twitter', 'https://twitter.com/getmixapp'),
        ...(accountSection || [])
      )
    )
  }

  renderHeading(label, modifier) {
    return (
      tag('div', {
        className: bem.element('heading', modifier)
      },
        label
      )
    )
  }

  renderHref(label, href) {
    return (
      tag('a', {
        href,
        className: bem.element('href', label.toLowerCase())
      },
        label
      )
    )
  }

  renderSocialAccounts() {
    return (
      tag('div', {
        className: bem.element('social-accounts')
      },
        SOCIAL_ACCOUNTS.map(account =>
          tag('a', {
            key: account.provider,
            className: bem.element('social-account', account.provider),
            href: account.href,
            rel: 'external nofollow noopener',
            target: '_blank',
            title: account.title
          },
            tag(Icon, { id: account.provider })
          )
        )
      )
    )
  }

  render() {
    if (this.props.hidden) {
      return null
    }
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag('div', {
          className: bem.element('columns-row')
        },
          this.renderBrandingColumn(),
          this.renderCompanyColumn(),
          this.renderFollowColumn(),
          this.renderDownloadColumn()
        ),
        tag('div', {
          className: bem.element('copyright-row')
        },
          this.renderCopyright(),
          this.renderSocialAccounts()
        )
      )
    )
  }
}

AppFooter.propTypes = {
  // Values
  className: PropTypes.string,
  hidden: PropTypes.bool,
  loggedIn: PropTypes.bool,
  // Callbacks
  onContactClick: PropTypes.func
}

module.exports = AppFooter
